import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SharedUtilToastModule, ToastAnimation } from '@mode/shared/util-toast';
import { Toast } from 'ngx-toastr';

@Component({
  selector: 'mode-google-sheet-ingest-progress',
  templateUrl: './google-sheet-ingest-progress.component.html',
  styleUrls: ['./google-sheet-ingest-progress.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [ToastAnimation],
  imports: [SharedUtilToastModule],
  standalone: true,
})
export class GoogleSheetIngestProgressComponent extends Toast {}
